/* global projectContext */
var React = require("react");
var _ = require('underscore');
const createReactClass = require('create-react-class');
const LetsEncrypt = require('../../deploynaut-ssl/js/LetsEncrypt.jsx');

var Configuration = createReactClass({
	render: function() {
		let rows = [];
		for (var key in this.props.model.Data) {
			let val = this.props.model.Data[key];

			if (val == '' || key == '') {
				continue
			}

			if (!Array.isArray(val) && val.indexOf(',') >= 0) {
				val = val.split(',')
			}

			if (Array.isArray(val)) {
				val = val.join(', ')
			}

			let small = '';
			switch(key) {
				case 'a':
					small = 'A DNS records for your root domains';
					key = 'A DNS records';
					break;
				case 'cname':
					small = 'CNAME DNS records for any subdomains (including www domains)';
					key = 'CNAME DNS records';
					break;
				case 'aliases':
					small = 'Domains which will accept HTTP traffic';
					key = 'HTTP domains';
					break;
				case 'alias_prime':
					small = 'Domains which will accept secure traffic';
					key = 'HTTPS domains';
					break;
				case 'general_whitelist':
					small = 'IP addresses which can access the entire site';
					break;
				case 'admin_whitelist':
					small = 'IP addresses which can access URLs starting with "/admin"';
					break;
				case 'security_whitelist':
					small = 'IP addresses which can access URLS starting with "/security"';
					break;
				case 'server_type':
					key = 'Stack size';
					break;
				case 'cluster':
					val = val.replace('mgmt', '');
					break;
				default:
					small = ''
			}

			// Make any params nicer to humans i.e. general_whitelist -> general whitelist
			if (key.indexOf('_') >= 0) {
				key = key.split('_')
				key = key.join(' ')
			}

			rows.push(
				<tr key={key}>
					<td>{key}<br /><small>{small}</small></td>
					<td>{val}</td>
				</tr>
			)
		}

		let leDomains;
		if (this.props.model.LetsEncryptDomains.length > 0) {
			leDomains = (
				<div>
					<h3>Let's Encrypt</h3>
					<LetsEncrypt
						model={this.props.model}
						afterSuccess={null}
						cancelHandler={null}
					/>
				</div>
			)
		}

		return (
			<div>
				<h3>Environment configuration</h3>
				<p>Please raise a ticket <a href="https://servicedesk.silverstripe.cloud">with Service Desk</a> to change these settings. It may take up to two hours to see a change reflected in this section.</p>
				<div className="table-responsive">
					<table className="table">
						<thead>
							<tr>
								<th width="25%">Key</th>
								<th>Value</th>
							</tr>
						</thead>
						<tbody>
							{rows}
						</tbody>
					</table>
				</div>

				{leDomains}
			</div>
		);
	}
});


module.exports = Configuration;
